export default __webpack_public_path__ + "static/media/wyw.2d84eec5.PNG";